import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            fontColor: 'rgb(255, 255, 255)'
          }
        },
        tooltips: {
          enabled: true,
          displayColors: false
        },
        scales: {
          xAxes: [{
            display: true,
            type: 'time',
            distribution: 'linear',
            time: {
              unit: 'month',
              min: '2018-11-25'
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 20
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
